"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountCommandType = exports.AccountCommandStatusReason = exports.AccountCommandStatus = void 0;
var AccountCommandStatus;
(function (AccountCommandStatus) {
    AccountCommandStatus["PENDING"] = "PENDING";
    AccountCommandStatus["COMPLETED"] = "COMPLETED";
})(AccountCommandStatus = exports.AccountCommandStatus || (exports.AccountCommandStatus = {}));
var AccountCommandStatusReason;
(function (AccountCommandStatusReason) {
    AccountCommandStatusReason["FAILED"] = "FAILED";
    AccountCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
})(AccountCommandStatusReason = exports.AccountCommandStatusReason || (exports.AccountCommandStatusReason = {}));
var AccountCommandType;
(function (AccountCommandType) {
    AccountCommandType["ADD_AFFILIATES"] = "ADD_AFFILIATES";
    AccountCommandType["ADD_AFFINITY_GROUPS"] = "ADD_AFFINITY_GROUPS";
    AccountCommandType["ADD_EXTERNAL_ROLE"] = "ADD_EXTERNAL_ROLE";
    AccountCommandType["ARCHIVE"] = "ARCHIVE";
    AccountCommandType["ARCHIVE_IDENTITY"] = "ARCHIVE_IDENTITY";
    AccountCommandType["BULK_UPDATE_EXTERNAL_ROLES"] = "BULK_UPDATE_EXTERNAL_ROLES";
    AccountCommandType["CREATE_COMMERCIAL_ACCOUNT"] = "CREATE_COMMERCIAL_ACCOUNT";
    AccountCommandType["CREATE_PERSONAL_ACCOUNT"] = "CREATE_PERSONAL_ACCOUNT";
    AccountCommandType["MERGE_FROM"] = "MERGE_FROM";
    AccountCommandType["MERGE_INTO"] = "MERGE_INTO";
    AccountCommandType["MIGRATE"] = "MIGRATE";
    AccountCommandType["REMOVE_AFFILIATION"] = "REMOVE_AFFILIATION";
    AccountCommandType["REMOVE_AFFINITY_GROUPS"] = "REMOVE_AFFINITY_GROUPS";
    AccountCommandType["REMOVE_EXPIRED_ACCOUNT_ROLE_MAPPING"] = "REMOVE_EXPIRED_ACCOUNT_ROLE_MAPPING";
    AccountCommandType["REMOVE_EXTERNAL_ROLE"] = "REMOVE_EXTERNAL_ROLE";
    AccountCommandType["REMOVE_PRIMARY_ACCOUNT_MANAGEMENT"] = "REMOVE_PRIMARY_ACCOUNT_MANAGEMENT";
    AccountCommandType["REMOVE_PRIMARY_PRODUCER"] = "REMOVE_PRIMARY_PRODUCER";
    AccountCommandType["REMOVE_SECONDARY_ACCOUNT_MANAGEMENT"] = "REMOVE_SECONDARY_ACCOUNT_MANAGEMENT";
    AccountCommandType["REMOVE_SECONDARY_PRODUCER"] = "REMOVE_SECONDARY_PRODUCER";
    AccountCommandType["REPLICATE"] = "REPLICATE";
    AccountCommandType["REVERT_VERIFICATION"] = "REVERT_VERIFICATION";
    AccountCommandType["SET_ACCOUNT_MANAGEMENT"] = "SET_ACCOUNT_MANAGEMENT";
    AccountCommandType["SET_BROKER_OF_RECORD"] = "SET_BROKER_OF_RECORD";
    AccountCommandType["SET_CLIENT_ACCESS_FEATURES"] = "SET_CLIENT_ACCESS_FEATURES";
    AccountCommandType["SET_FOLLOWUP_DATE"] = "SET_FOLLOWUP_DATE";
    AccountCommandType["SET_IDENTITY"] = "SET_IDENTITY";
    AccountCommandType["SET_LEAD_STATUS"] = "SET_LEAD_STATUS";
    AccountCommandType["SET_LEGACY_CLIENT_DATA"] = "SET_LEGACY_CLIENT_DATA";
    AccountCommandType["SET_NET_WORTH"] = "SET_NET_WORTH";
    AccountCommandType["SET_PENDING_VERIFICATION"] = "SET_PENDING_VERIFICATION";
    AccountCommandType["SET_PRIMARY_CONTACT"] = "SET_PRIMARY_CONTACT";
    AccountCommandType["SET_PRODUCER"] = "SET_PRODUCER";
    AccountCommandType["TRIGGER_BACKFILL_ACLS"] = "TRIGGER_BACKFILL_ACLS";
    AccountCommandType["UNARCHIVE"] = "UNARCHIVE";
    AccountCommandType["UPDATE_COMMERCIAL_ACCOUNT"] = "UPDATE_COMMERCIAL_ACCOUNT";
    AccountCommandType["UPDATE_NOTES"] = "UPDATE_NOTES";
    AccountCommandType["UPDATE_PERSONAL_ACCOUNT"] = "UPDATE_PERSONAL_ACCOUNT";
    AccountCommandType["VERIFY"] = "VERIFY";
})(AccountCommandType = exports.AccountCommandType || (exports.AccountCommandType = {}));
//# sourceMappingURL=account-command.js.map